export default "__VITE_ASSET__6a721737__"